module.exports = __webpack_public_path__ + "static/media/study220419.1e5066c6.png";